import { render, staticRenderFns } from "./AssPlanoSafraPropriedade.vue?vue&type=template&id=019e398e&scoped=true"
import script from "./AssPlanoSafraPropriedade.vue?vue&type=script&lang=js"
export * from "./AssPlanoSafraPropriedade.vue?vue&type=script&lang=js"
import style0 from "./AssPlanoSafraPropriedade.vue?vue&type=style&index=0&id=019e398e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "019e398e",
  null
  
)

export default component.exports